var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VButton',_vm._g({staticClass:"button_dropdown"},_vm.listeners),[_vm._t("default"),(_vm.isShowDropdown)?_c('ul',{staticClass:"button-dropdown-items",class:{
            'button-dropdown-items_bottom-left': _vm.bottomLeft,
            'button-dropdown-items_bottom-right': _vm.bottomRight,
        }},[_vm._l((_vm.actions),function(action,index){return [_c('li',{key:index,staticClass:"button-dropdown-items__item",on:{"click":function($event){$event.stopPropagation();return _vm.callAction(action.action)}}},[_vm._v(" "+_vm._s(action.name)+" ")])]})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }